module.exports = __webpack_public_path__ + "static/media/ustawienia.3425af32.svg";